import MySchedule from "./myschedule";

export default MySchedule;
